import React, { useEffect, useMemo, useState } from 'react';
import '../styles/ContactsTab.css';
import '../styles/Common.css';
import AddContact from './AddContact';
import UpdateContact from './UpdateContact';
import { useDebounce } from '../hooks/useDebounce';
import { get_all_contacts, delete_contact } from '../api/contact_api'
import SendEmail from './SendEmail';

const ContactsTab = ({ onClose }) => {
    const [contacts, setContacts] = useState([]);
    const [editingContact, setEditingContact] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearch = useDebounce(searchTerm, 300);
    const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);

    const fetchContacts = async () => {
        try {
            const contacts = await get_all_contacts();
            const enrichedData = contacts.map(c => ({
                ...c,
                searchKey: `${c.full_name || ''} ${c.email || ''} ${c.phone || ''}`.toLowerCase()
            }));
            setContacts(enrichedData);
        } catch (err) {
            console.log('טעינת אנשי הקשר נכשלה');
            console.error(err);
            setError('טעינת אנשי הקשר נכשלה');
        }
    };

    useEffect(() => {
        fetchContacts();
    }, []);

    const filteredContacts = useMemo(() => {
        const term = debouncedSearch.toLowerCase();
        return contacts.filter(b => {
            const searchKey = b.searchKey || '';
            return searchKey.includes(term);
        });
    }, [debouncedSearch, contacts]);

    const deleteContact = async (contact_id) => {
        if (window.confirm("האם אתה בטוח שברצונך למחוק את איש הקשר?")) {
            try {
                await delete_contact(contact_id);
                // setContacts(contacts.filter((contact) => contact.id !== deleted_contact_id));
                setContacts(prevContacts =>
                    prevContacts.filter((contact) => contact.id !== contact_id)
                );
                alert('מחיקת איש הקשר בוצעה בהצלחה');
            } catch (err) {
                console.error(err);
                alert('מחיקת איש הקשר נכשלה');
            }
        }
    }

    const sendEmail = (email) => {
        setSelectedEmail(email);
        setIsEmailPopupOpen(true);
    };

    const handleContactAdded = async () => {
        await fetchContacts();
        setShowForm(false);
    };

    return (
        <>
            {!showForm ? (
                <div className="contacts-tab">
                    <div className="contacts-header">
                        <h2 className="contacts-h2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                fill="none" stroke="#150F6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M4 21v-2a4 4 0 0 1 3-3.87" />
                                <circle cx="12" cy="7" r="4" />
                            </svg>
                            אנשי קשר
                        </h2>
                        <div className="contact-search-container">
                            <svg className="contact-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" fill="none">
                                <path d="M14.3269 14.44L17.8 17.8M16.68 8.84C16.68 13.1699 13.1699 16.68 8.84 16.68C4.51009 16.68 1 13.1699 1 8.84C1 4.51009 4.51009 1 8.84 1C13.1699 1 16.68 4.51009 16.68 8.84Z" stroke="#727171" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <div className="contact-search-wrapper">
                                <input type="text" className="contact-search-input" value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)} placeholder="חיפוש" />
                                <div className="contact-search-line"></div>
                            </div>
                        </div>
                        <button id="contact-close-btn" className="close-btn btn" onClick={onClose} title="סגור">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                    <div className="contacts-list">
                        {(error || filteredContacts.length == 0) ? (
                            <p>{error || 'לא נמצאו אנשי קשר. להוספה לחצו על הוספת איש קשר'}</p>
                        ) : (
                            filteredContacts.map(contact => (
                                <div key={contact.id} className="contact-item">
                                    <div className="contact-info">
                                        <strong style={{ color: '#7879F1' }}>{contact.full_name}</strong>
                                        <div>{contact.email}</div>
                                        <div>{contact.phone}</div>
                                    </div>
                                    <div className="action-cell">
                                        <button className="icon-btn" title="עדכן" onClick={() => { setEditingContact(contact); setShowForm(true) }}>
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M12 20h9" />
                                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                            </svg>
                                        </button>
                                        <button className="icon-btn" title="מחק" onClick={() => deleteContact(contact.id)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M3 5.5H17M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5M9 8.5V15.5M11 8.5V15.5M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                                            </svg>
                                        </button>
                                        <button className='icon-btn' title='שלח אימייל' onClick={() => sendEmail(contact.email)}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                                strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z" />
                                                <polyline points="22,6 12,13 2,6" />
                                            </svg>
                                        </button>
                                    </div>
                                    {isEmailPopupOpen && selectedEmail === contact.email && (
                                        <SendEmail
                                            onClose={() => setIsEmailPopupOpen(false)}
                                            recipientEmail={selectedEmail}
                                        />
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                    <button className="add-contact-btn btn" onClick={() => setShowForm(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        הוספת איש קשר
                    </button>
                </div>) : (
                editingContact ? (
                    <UpdateContact
                        onCancel={() => { setEditingContact(null); setShowForm(false) }}
                        onClose={onClose}
                        contact={editingContact}
                        onContactAdded={handleContactAdded}
                    />
                ) : (
                    <AddContact
                        onCancel={() => setShowForm(false)}
                        onClose={onClose}
                        onContactAdded={handleContactAdded}
                    />
                ))}
        </>
    );
};

export default ContactsTab;
